module.exports = __webpack_public_path__ + "68dc61893c7a5b72afc66a2ad2ef4790.svg";